import { Injectable } from '@angular/core';
import { HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';

import { UploadIds } from 'src/app/models/upload';
import { InformativePage } from 'src/app/models/informative-page';
import { ApiService } from 'src/app/core/services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class InformativePagesService {
  getInformativePages(studyId: number): Observable<InformativePage[]> {
    return this.apiService.get<InformativePage[]>(`/dashboard/study/${studyId}/pages`);
  }

  createInformativePage(page): Observable<InformativePage> {
    return this.apiService.post<InformativePage>(`/dashboard/study/${page.study_id}/page`, page);
  }

  updateInformativePage(page): Observable<InformativePage> {
    return this.apiService.put<InformativePage>(`/dashboard/study/${page.study_id}/page/${page.page_id}`, page);
  }

  deleteInformativePage(page): Observable<InformativePage> {
    return this.apiService.delete<InformativePage>(`/dashboard/study/${page.study_id}/page/${page.id}`, page);
  }

  constructor(private apiService: ApiService) {}
}
